import * as React from 'react'
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" {...props}>
    <g fill="#000" fillRule="nonzero">
      <path d="M34.757 19.444a1.5 1.5 0 0 1 1.678 2.487l-11.613 7.836a1.5 1.5 0 0 1-1.691-.01l-11.35-7.835a1.5 1.5 0 1 1 1.705-2.469l10.506 7.254 10.765-7.263Z" />
      <path d="M39 10a5 5 0 0 1 5 5v19a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V15a5 5 0 0 1 5-5h30Zm0 2H9a3 3 0 0 0-3 3v19a3 3 0 0 0 3 3h30a3 3 0 0 0 3-3V15a3 3 0 0 0-3-3Z" />
    </g>
  </svg>
)
export default SvgComponent
